// For Get insurance_carriers
export const GET_CALL_SUMMARY = "GET_CALL_SUMMARY"
export const GET_CALL_SUMMARY_SUCCESS = "GET_CALL_SUMMARY_SUCCESS"
export const GET_CALL_SUMMARY_ERROR = "GET_CALL_SUMMARY_ERROR"
